// extracted by mini-css-extract-plugin
export default {"close":"close__dS9th","grey":"grey__BnZSw","green":"green__RMxCu","plain":"plain__VM8E3"};